import { FC, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Filter, Href, SortBy } from "../../../../constants";
import { FilterTabsListData } from "../../../../data/Property";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setSortValue, setSortBy } from "../../../../reduxToolkit/reducers/filterSlice";
import { setCardToShow, setOpenFilterSidebar } from "../../../../reduxToolkit/reducers/layoutSlice";
import { TopPanelType } from "../../../../types/Product";
import HeaderFilter from "./HeaderFilter";
import { SearchNormal1 } from "iconsax-react";

const FilterTags: FC<TopPanelType> = ({ topFilterSidebar, side, mainClass, type, jobBoxStyle, searchName, setSearchname }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { sortBy } = useAppSelector((state) => state.filter);
  const { totalProduct } = useAppSelector((state) => state.layout);

  const handleSortBy = (sortOption: any) => {
    // if (sortOption === "Most Popular") dispatch(setPopular(sortOption));
    // if (sortOption === "24 Product par page") dispatch(setCardToShow(24));
    dispatch(setSortValue(sortOption.value));
    dispatch(setSortBy(sortOption.name));
    setDropdownOpen(false);
  };

  const renderDropdown = (startPoint: number, endPoint: number) => (
    <Dropdown className="select-dropdown" isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
      <DropdownToggle className="select-button">{sortBy || "Sort By"}</DropdownToggle>
      <DropdownMenu className="select-menu" end>
        {
          [
            {
              name: '$ High To Low',
              value: { price: -1 },
            },
            {
              name: '$ Low To High',
              value: { price: 1 },
            },
            {
              name: 'Certified',
              value: { badgeFilter: 'Certified' },
            },
            {
              name: 'Unregistered',
              value: { badgeFilter: 'Unregistered' },
            },
          ].map((x, i) => {
            return (
              <DropdownItem tag="a" onClick={() => handleSortBy(x)} key={i} className="select-item" active={sortBy === x.name}>
                {x.name}
              </DropdownItem>
            )
          })
        }
        {/* {FilterTabsListData.slice(startPoint, endPoint).map((item, index) => (
          <DropdownItem tag="a" onClick={() => handleSortBy(item)} key={index} className="select-item" active={sortBy === item}>
            {item}
          </DropdownItem>
        ))} */}
      </DropdownMenu>
    </Dropdown>
  );

  return (
    <div className={mainClass ? mainClass : "top-panel"}>
      {jobBoxStyle === "header-filter" && <HeaderFilter />}
      {type === "job" ? (
        <div className="category-filter-flex">
          <h5>All {totalProduct} jobs got found</h5>
          <div className="category-filter">
            {!topFilterSidebar && (
              <a href={Href} className={`btn-solid ${side !== "no" && "filter-btn"}`} onClick={() => dispatch(setOpenFilterSidebar())}>
                {Filter}
              </a>
            )}
            <div className="category-filter">
              <span>{SortBy}</span>
              {renderDropdown(3, 8)}
            </div>
          </div>
        </div>
      ) : (
        <>
          <h4>
            {totalProduct} {type === "property" ? "properties in Amsterdam" : "Cars To Explore"}
          </h4>
          {type === "property" ? (
            <>
              {renderDropdown(0, 3)}
              {!topFilterSidebar && (
                <a href={Href} className={`btn-solid ${side !== "no" && "filter-btn"}`} onClick={() => dispatch(setOpenFilterSidebar())}>
                  {Filter}
                </a>
              )}
            </>
          ) : (
            <div className="category-filter">
              <div className="search-input">
                  <SearchNormal1 className="iconsax" />
                  <input 
                    type="search" 
                    className="form-control" 
                    placeholder="Search Name" 
                    value={searchName}
                    onChange={(e) => setSearchname(e.target.value)}
                  />
                </div>
              <div className="car-sortby-flex">
                <span>{SortBy}</span>
                {renderDropdown(3, 8)}
              </div>
              {/* {!topFilterSidebar && (
                <a href={Href} className={`btn-solid ${side !== "no" && "filter-btn"}`} onClick={() => dispatch(setOpenFilterSidebar())}>
                  {Filter}
                </a>
              )} */}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FilterTags;
